/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GPD
 */
export interface GPD {
  /**
   *
   * @type {string}
   * @memberof GPD
   */
  readonly uuid?: string;
  /**
   *
   * @type {Date}
   * @memberof GPD
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof GPD
   */
  readonly updated?: Date;
  /**
   * Alleen beschikbaar voor de eigenaar van de put.
   * @type {string}
   * @memberof GPD
   */
  internalId: string | null;
  /**
   *
   * @type {string}
   * @memberof GPD
   */
  broId: string;
  /**
   *
   * @type {string}
   * @memberof GPD
   */
  deliveryAccountableParty: string | null;
  /**
   *
   * @type {string}
   * @memberof GPD
   */
  qualityRegime: string | null;
  /**
   *
   * @type {Date}
   * @memberof GPD
   */
  startTime: Date | null;
  /**
   *
   * @type {Date}
   * @memberof GPD
   */
  endTime: Date | null;
  /**
   *
   * @type {string}
   * @memberof GPD
   */
  dataOwner: string;
}

/**
 * Check if a given object implements the GPD interface.
 */
export function instanceOfGPD(value: object): value is GPD {
  if (
    (!("internalId" in (value as Record<string, any>)) &&
      !("internal_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["internalId"] === undefined &&
      (value as Record<string, any>)["internal_id"] === undefined)
  )
    return false;
  if (
    (!("broId" in (value as Record<string, any>)) &&
      !("bro_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["broId"] === undefined &&
      (value as Record<string, any>)["bro_id"] === undefined)
  )
    return false;
  if (
    (!("deliveryAccountableParty" in (value as Record<string, any>)) &&
      !("delivery_accountable_party" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["deliveryAccountableParty"] === undefined &&
      (value as Record<string, any>)["delivery_accountable_party"] === undefined)
  )
    return false;
  if (
    (!("qualityRegime" in (value as Record<string, any>)) &&
      !("quality_regime" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["qualityRegime"] === undefined &&
      (value as Record<string, any>)["quality_regime"] === undefined)
  )
    return false;
  if (
    (!("startTime" in (value as Record<string, any>)) &&
      !("start_time" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["startTime"] === undefined &&
      (value as Record<string, any>)["start_time"] === undefined)
  )
    return false;
  if (
    (!("endTime" in (value as Record<string, any>)) &&
      !("end_time" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["endTime"] === undefined &&
      (value as Record<string, any>)["end_time"] === undefined)
  )
    return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function GPDFromJSON(json: any): GPD {
  return GPDFromJSONTyped(json, false);
}

export function GPDFromJSONTyped(json: any, ignoreDiscriminator: boolean): GPD {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    internalId: json["internal_id"],
    broId: json["bro_id"],
    deliveryAccountableParty: json["delivery_accountable_party"],
    qualityRegime: json["quality_regime"],
    startTime: json["start_time"] == null ? null : new Date(json["start_time"]),
    endTime: json["end_time"] == null ? null : new Date(json["end_time"]),
    dataOwner: json["data_owner"],
  };
}

export function GPDToJSON(json: any): GPD {
  return GPDToJSONTyped(json, false);
}

export function GPDToJSONTyped(
  value?: Omit<GPD, "uuid" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    internal_id: value["internalId"],
    bro_id: value["broId"],
    delivery_accountable_party: value["deliveryAccountableParty"],
    quality_regime: value["qualityRegime"],
    start_time:
      value["startTime"] == null
        ? value["startTime"]
        : value["startTime"].toISOString().substring(0, 10),
    end_time:
      value["endTime"] == null ? value["endTime"] : value["endTime"].toISOString().substring(0, 10),
    data_owner: value["dataOwner"],
  };
}
